<label [for]="name()" class="flex min-h-[32px] w-full flex-col">
  @if (!labelTemplate()) {
    @if (label()) {
      <span class="mb-2">{{ label() }}</span>
    }
  } @else {
    <div class="mb-2">
      <ng-container
        [ngTemplateOutlet]="labelTemplate()"
        [ngTemplateOutletContext]="{ $implicit: label() }" />
    </div>
  }

  <div
    id="input-container"
    [ngClass]="{
      'border-error has-[:focus]:ring-error': showError(),
      'border-theme-secondary-gray has-[:focus]:ring-theme-secondary-gray': !showError(),
      'bg-theme-gray-400 cursor-not-allowed opacity-60': disabled(),
    }"
    class="hover:bg-theme-gray-400 has-[:focus]:bg-theme-gray-400 flex w-full grow gap-2 rounded border px-2 py-1 transition has-[:focus]:ring-1">
    <ng-content></ng-content>
    <input
      class="w-full grow border-none bg-inherit p-0 outline-none focus:ring-0"
      type="number"
      [id]="name()"
      [placeholder]="placeholder()"
      [value]="value()"
      [isFocused]="isFocused()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      (input)="onInput($event)"
      (click)="clicked.emit()" />
  </div>
  @if (showError()) {
    @for (error of validationErrors(); track error) {
      <span class="text-error">{{ error.message }}</span>
    }
  }
</label>
